module.exports = __webpack_public_path__ + "static/media/assets.9d89e6ba.svg";